import { FocusService } from '@/core/services/focus.service';
import { OnDestroy, Directive } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Directive()
export abstract class FocusManagedDialogComponent  extends DialogContentBase implements OnDestroy {

  constructor(protected focusService: FocusService, dialog: DialogRef) {
    super(dialog);
    this.focusService.storeFocusedElement();
  }

  ngOnDestroy() {
    this.focusService.returnFocus();
  }
}